import "./Footer.css";
import { Link,NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-section text-light pt-5">
      <div className="container">
        <div className="row gy-4">

          {/* Brand */}
          <div className="col-md-3">
            <h5 className="footer-title">Code Inputs</h5>
            <p className="footer-text">
              Building smart digital solutions with modern technology.
            </p>

            {/* Social Icons */}
            <div className="social-icons mt-3">
              <a href="https://www.facebook.com/profile.php?id=61563461764043" className="me-3"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/codeinputs_24/" className="me-3"><i className="bi bi-instagram"></i></a>
              <a href="https://www.youtube.com/@CodeInputs" className="me-3"><i className="bi bi-youtube"></i></a>
              <a href="https://in.pinterest.com/codeinputs/" className="me-3"><i className="bi bi-pinterest"></i></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-3">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-list">
              <li><NavLink to="/privacypolicy" className={({ isActive }) => (isActive ? "active" : "")}>Privacy Policy</NavLink></li>
              <li><NavLink to="/disclaimer" className={({ isActive }) => (isActive ? "active" : "")}>Diclaimer</NavLink></li>
              <li><NavLink to="/termsncondition" className={({ isActive }) => (isActive ? "active" : "")}>Terms & Condition</NavLink></li>
              <li><NavLink to="/sitemap" className={({ isActive }) => (isActive ? "active" : "")}>Sitemap</NavLink></li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-3">
            <h5 className="footer-title">Services</h5>
            <ul className="footer-list">
              <li className="footer-text">Web Development</li>
              <li><a className="footer-text">Software Development</a></li>
              <li><a className="footer-text">Custom API Creation & Integration</a></li>
              <li><a className="footer-text">Graphics Designing</a></li>
              <li><a className="footer-text">Logo Designing</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-3">
            <h5 className="footer-title">Contact</h5>
            <p className="footer-text mb-2">
              Email: codeinputs@gmail.com
            </p>
            <p className="footer-text">
              Phone: +91 7693890243
            </p>
          </div>

        </div>

        {/* Bottom */}
        <div className="text-center mt-5 border-top pt-3 footer-bottom">
          © 2026 Code Inputs. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
